'use strict';

import defaultTemplate from '../../core/default.html';
import reportsListTemplate from './reports.list.html';
import systemStatusTemplate from './reports.status.html';

import Reports from './reports.ctrl';

function ReportsRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.reports', {
      url: '/reports',
      template: defaultTemplate,
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewReportList()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.reports.list');
        }
      }
    })
    .state('main.reports.list', {
      url: '/list',
      template: reportsListTemplate,
      controller: 'ReportsListController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewReportList()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.reports.list');
        }
      }
    })
    .state('main.reports.status', {
      url: '/status',
      template: systemStatusTemplate,
      controller: 'ReportsSystemStatusController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewReportList()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.reports.status');
        }
      }
    });
}

export default angular
  .module('reports.router', [
    Reports
  ])
  .config(ReportsRouter)
  .name;
